import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class FilingSupportingDocApi<FilingSupportingDocument> extends BaseAPI {
  // constructor() {}

  public getFilingSupportingDocByFilingId: (filingId: number) => Promise<FilingSupportingDocument> =
    async (filingId: number) => {
      return (
        await BaseAPI.axios.get(`${baseUrl}/FilingSupportingDocument/GetByFilingId/${filingId}`)
      ).data.output;
    };

  public createSupportingDoc: (
    document: FilingSupportingDocument
  ) => Promise<FilingSupportingDocument> = async (document: any) => {
    let documentTitleEncoded = document;

    if(documentTitleEncoded.originalName){
      documentTitleEncoded.originalName = btoa(unescape(encodeURIComponent(documentTitleEncoded.originalName)));
    }

    return (await BaseAPI.axios.post(`${baseUrl}/FilingSupportingDocument`, documentTitleEncoded)).data.output;
  };

  public deleteByBlobName: (blobName: string) => Promise<string> = async (blobName: any) => {
    return (await BaseAPI.axios.delete(`${baseUrl}/FilingSupportingDocument/${blobName}`)).data
      .output;
  };
}

export const filingSupportingDocAPI = new FilingSupportingDocApi();
